/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getProfile.defs.js'
export * as $defs from './getProfile.defs.js'
